/* eslint-disable max-lines */
import { ca } from '@cian/analytics';

import { IJsonQuery } from '../../../json_query';
import { IOffer } from '../../../offer/types';
import { ITrackingKpAdvantage } from '../../../utils/trackings';

interface IParams {
  offerId: number;
  position: number;
  kpAdvantages?: ITrackingKpAdvantage[];
}

interface IFolderNameClickParams {
  offerId: number;
  folderId: number;
  position: number;
}

export function trackFavoriteAdded(searchConditions: IJsonQuery, params: IParams, label?: string, source?: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'favorite',
    action: 'add_from_newlist',
    label,
    searchConditions,
    products: [
      {
        id: params.offerId,
        offerType: 'offer',
        position: params.position,
        extra: {
          kpAdvantages: params.kpAdvantages,
          source,
        },
      },
    ],
  });
}

export function trackFavoriteRemoved(searchConditions: IJsonQuery, params: IParams, label?: string) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'favorite',
    action: 'remove_from_newlist',
    label,
    searchConditions,
    products: [
      {
        id: params.offerId,
        offerType: 'offer',
        position: params.position,
      },
    ],
  });
}

export function trackCreateFolder(params: IParams) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'add_collection',
    label: 'from_card',
    products: [
      {
        id: params.offerId,
        offerType: 'offer',
        position: params.position,
      },
    ],
  });
}

export function trackSaveToFolder(params: IParams) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'add_to_collection',
    label: '',
    products: [
      {
        id: params.offerId,
        offerType: 'offer',
        position: params.position,
      },
    ],
  });
}

export function trackFolderNameClick(params: IFolderNameClickParams) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'ListingFavorites',
    action: 'click_collection_name',
    label: params.folderId,
    products: [
      {
        id: params.offerId,
        offerType: 'offer',
        position: params.position,
      },
    ],
  });
}

export function trackPhotoSlideChanged(offerId: number, position: number) {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'slide_photo',
    label: 'from_newlist',
    products: [
      {
        id: offerId,
        offerType: 'offer',
        position,
      },
    ],
  });
}

export function trackJKLinkClicked(offer: IOffer) {
  let label = '';

  if (offer.geo && offer.geo.jk && offer.geo.jk.gaGeo) {
    const { moId, oblId, cityId } = offer.geo.jk.gaGeo;
    label = `/newobject_name/mo_id=${moId}/obl_id=${oblId}/city_id=${cityId}/`;
  }

  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'to_card_newbuilding',
    label,
  });

  ca('eventSite', {
    name: 'oldevent',
    category: 'Listing',
    action: 'to_cardJK',
    label: '',
    products: [
      {
        id: offer.geo?.jk?.id || 0,
        offerType: 'JK',
        position: 0,
      },
    ],
  });
}

export function trackMenuOpened() {
  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'moreMenu_open',
  });
}

export function trackPDFLinkClicked() {
  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'moreMenu_download_pdf',
    label: 'from_newlist',
  });
}

export function trackDocLinkClicked() {
  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'moreMenu_download_doc',
    label: 'from_newlist',
  });
}

export const trackMoreSuggestionsButtonClicked = (label: string = '') => {
  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'show_more_similar',
    label,
  });
};

export function trackGoToMessages() {
  ca('event', {
    action: 'go_to_messages',
    category: 'card',
    label: '',
    name: 'oldevent',
  });
}

export function trackMapOpened() {
  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'open_map',
    label: 'from_newlist',
  });
}

export function trackMapClosed() {
  ca('event', {
    name: 'oldevent',
    category: 'Listing',
    action: 'hide_map',
    label: 'from_newlist',
  });
}
